module.exports = __webpack_public_path__ + "./imgs/biz_content_02_bg.png?b7c3375f8da4b407281b6eca62a5efd4";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/biz_content_02_bg.png
// module id = 9
// module chunks = 0 1 2 3 4 5 6